export function getTicketsUrl(event: { ticketsSeller: string; ticketsUrl: string }): string {
    if (event.ticketsSeller === 'BLUETICKET') {
        return event.ticketsUrl
    }
    return 'https://ticketline.pt/evento/' + event.ticketsUrl
}
